<div class="tab-pane" role="tabpanel" id="recepcion">
    <fieldset id="agregar_recepcion" class="">
        <div class="step_section">
            <h3 class="form-signin-heading"><strong>Recepcion Parcial</strong></h3>
            <hr>
            <form [formGroup]="form">
                <div class="form-horizontal">
                    <div class="form-group" align="left">
                        <div class="col-md-3">
                            <label for="dproy">Superficie Edificada que se recepciona</label>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="Superficie" id="superedif" name="superedif" formControlName="superedif" (change)="add_recepcion()" [errorStateMatcher]="matcher">
                                <span matSuffix>m²</span>
                                <mat-error *ngIf="form.controls?.superedif.hasError('required')">
                                    Este campo es <strong>obligatorio</strong>
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <label class="col-md-3 control-label" for="destino_cont">Destino Contemplado</label>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="Destino Contempaldo" id="destino_cont" name="destino_cont" formControlName="destino_cont" (change)="add_recepcion()" [errorStateMatcher]="matcher">
                                <mat-error *ngIf="form.controls?.destino_cont.hasError('required')">
                                    Este campo es <strong>obligatorio</strong>
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </fieldset>
</div>
<div class="separator"></div>